import clsx from 'clsx'
import { Button, Col, Container, Grid, Row, Typography } from 'gu-ui-kit'
import formStyles from 'modules/Forms/common-form.module.scss'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import useQueryParams from 'utils/hooks/useQueryParams'
import useWriteToClipboard from 'utils/hooks/useWriteToClipboard'
import styles from 'modules/Oauth/oauth.module.scss'
import { notificationShow } from 'modules/Notifications/actions'

const OauthCode = () => {
  const { t } = useTranslation()
  const { query } = useQueryParams()
  const writeToClipboard = useWriteToClipboard()
  const dispatch = useDispatch()
  const { md } = useBreakpoint()
  const isMobile = !md

  const toClipboard = useCallback((text) => {
    writeToClipboard(text)

    dispatch(
      notificationShow({
        type: 'success',
        message: 'common::notifications.success_copy_notification',
      }),
    )
  }, [])

  return (
    <Grid>
      <Row justifyContent="center">
        <Col sm="auto">
          <div className={clsx(formStyles['formContainer'], styles['container'])}>
            <div className={formStyles['formContainer__inner']}>
              <Typography variant={'Header-50'}>{t('oauth::code.title')}</Typography>
              <Typography variant={'Body-15'} component={'p'} color={'Label-Secondary'}>
                {t('oauth::code.description')}:
              </Typography>
              <Typography
                title={t('oauth::code.copy_to_buffer')}
                variant={'Body-15'}
                component={'div'}
                className={clsx(styles['code'], 'margin-bottom-8')}
                onClick={() => toClipboard(query.code || '')}
              >
                {query.code || '—'}
              </Typography>

              <Container display={'flex'} flexJustify={isMobile ? 'center' : 'flex-end'}>
                <Button
                  bgColor={'Label-GU-Primary'}
                  variant={'primary'}
                  onClick={() => toClipboard(query.code || '')}
                >
                  {t('oauth::code.copy_to_buffer')}
                </Button>
              </Container>
            </div>
          </div>
        </Col>
      </Row>
    </Grid>
  )
}

export default OauthCode
